/**
 * Template Context for passing configuration through component tree
 */

import { createContext, useContext } from "react";

export interface TableColumns {
  position?: boolean;
  description?: boolean;
  productType?: boolean;
  itemDate?: boolean;
  unit?: boolean;
  quantity?: boolean;
  unitPrice?: boolean;
  total?: boolean;
}

export interface CompanyDetails {
  name?: string;
  street?: string;
  houseNumber?: string;
  zip?: string;
  city?: string;
  country?: string;
  email?: string;
  phone?: string;
  website?: string;
  vatId?: string;
  taxNumber?: string;
  iban?: string;
  bic?: string;
  bankName?: string;
  court?: string;
  hrn?: string;
  contactFirstName?: string;
  contactLastName?: string;
  contactEmail?: string;
}

export interface TemplateContextType {
  tableColumns?: TableColumns;
  companyDetails?: CompanyDetails;
  logoUrl?: string | null;
  logoWidth?: number;
  logoHeight?: number;
  accentColor?: string;
}

const TemplateContext = createContext<TemplateContextType>({});

export function useTemplateContext() {
  return useContext(TemplateContext);
}

export const TemplateProvider = TemplateContext.Provider;
